<template>
    <div class="page">
        <div class="page-ctx">
            <div class="inner">
                <!-- banner -->
                <div class="banner-box">
                    <div class="lunbo-wrap">
                        <div class="lunbo-box">
                            <el-carousel
                                ref="carousel"
                                @mouseenter.native="delHandleMouseEnter"
                                @change="swiperChange"
                                trigger="click"
                                :autoplay="true"
                                :interval="5000"
                                :indicator-position="'none'"
                            >
                                <el-carousel-item v-for="(item, index) in index_banners" :key="index" @click.native="do_banner_click(item)">
                                    <img :src="item.image" alt="" />
                                    <div class="lunboTitleBox">
                                        <div class="lunboTitleFlexBox">
                                            <img src="@/assets/img/index/logo.png" class="lunboLogo" alt="" />
                                            <div class="lunboTitleText">Drums</div>
                                            <!-- <div class="lunboTitleText"><span style="color: #ff5310">HaiLun</span> Drums</div> -->
                                        </div>
                                        <div class="lunboTitleText2">{{ $t('敲响中国爵士鼓制造业的新乐章') }}</div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                            <!-- <div class="swiperHintFlexBox">
                                <div
                                    @click="switchSwiper(index)"
                                    class="swiperHint"
                                    :class="{ active: !!(swiperActiveIndex == index) }"
                                    v-for="(item, index) in index_banners"
                                    :key="index"
                                ></div>
                            </div> -->
                        </div>
                    </div>
                </div>

                <!-- 产品 -->
                <div class="productBigBox">
                    <div class="wrap visible">
                        <div style="width: 100%; height: 0.1px"></div>
                        <div class="pFlexBox">
                            <div class="pTopTitle">{{ $t('产品') }}</div>
                            <div class="rightBox" @click="goPage(5)"></div>
                        </div>
                        <div class="pSwiperBox">
                            <el-carousel height="300px" ref="pSwiper" trigger="click" indicator-position="none" arrow="never">
                                <el-carousel-item v-for="(item, index) in listFormate(pSearchSelectList)" :key="index">
                                    <div class="swiperFlexBox">
                                        <div class="swiperItemBox" @click="goProductListPage(item2)" v-for="(item2, index2) in item">
                                            <el-image class="img" :src="item2.thumb" fit="cover"></el-image>
                                            <div class="pSwiperText">{{ lang == 'en' ? item2.enTitle : item2.title }}</div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                            <div class="leftBtn" @click="pSwiperLeft"></div>
                            <div class="rightBtn" @click="pSwiperRight"></div>
                        </div>
                    </div>
                </div>

                <!-- 产品搜索 -->
                <!-- <div class="pSearchBgBox">
                    <div class="title">{{ $t('产品搜索') }}</div>
                    <el-select popper-class="pSelectpopper" class="pSelect" v-model="pSearchSelectVal" :placeholder="$t('请选择')">
                        <el-option v-for="item in pSearchSelectList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                    </el-select>
                    <el-input v-model="pInputValue" class="pInput" :placeholder="$t('请输入')"></el-input>
                    <div class="pQueryBtn" @click="queryBtnFun">
                        <img src="@/assets/img/index/queryBtn.png" class="queryBtn" alt="" />
                        <div class="queryBtnText">{{ $t('搜索') }}</div>
                    </div>
                </div> -->

                <!-- 私人订制 -->
                <div class="customBox">
                    <div class="wrap">
                        <div class="customTopFlexBox">
                            <div class="leftBox">
                                <!-- <div class="leftText">CUSTOM</div> -->
                                <div class="leftText2">{{ $t('私人定制') }}</div>
                            </div>
                            <div class="rightBox" @click="goPage(0)"></div>
                        </div>
                        <div class="swiperBox">
                            <el-carousel
                                :interval="5000"
                                :indicator-position="'none'"
                                height="100%"
                                ref="carousel2"
                                class="customSwiperItem"
                                @mouseenter.native="delHandleMouseEnter2"
                            >
                                <el-carousel-item class="customSwiperItem" v-for="(item, index) in madeBannerList" :key="index">
                                    <div class="customSwiperItem">
                                        <el-image class="img" :src="item.image" fit="contain"></el-image>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <!-- <div class="mediaBox">
                            <img src="@/assets/img/index/pic.png" class="mediaStyle" alt="" />
                        </div> -->
                        <!-- <div class="customTitleFlexBox">
                            <img src="@/assets/img/index/logo.png" class="lunboLogo" alt="" />
                            <div class="lunboTitleText">Drums</div>
                        </div> -->
                    </div>
                </div>

                <!-- 签约艺术家 -->
                <div class="productBigBox">
                    <div class="wrap visible">
                        <div style="width: 100%; height: 0.1px"></div>
                        <div class="pFlexBox noMt">
                            <div class="pTopTitle">{{ $t('签约艺术家') }}</div>
                            <div class="rightBox" @click="goPage(4)"></div>
                        </div>
                        <div class="pSwiperBox">
                            <el-carousel height="300px" ref="pSwiper2" trigger="click" indicator-position="none" arrow="never">
                                <el-carousel-item v-for="(item, index) in listFormate(artistList)" :key="index">
                                    <div class="swiperFlexBox">
                                        <div class="swiperItemBox" @click="goArtist(item2)" v-for="(item2, index2) in item" :key="index2">
                                            <el-image class="img" :src="item2.image" fit="cover"></el-image>
                                            <div class="pSwiperText">{{ lang == 'en' ? item2.enTitle : item2.title }}</div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                            <div class="leftBtn" @click="pSwiperLeft2"></div>
                            <div class="rightBtn" @click="pSwiperRight2"></div>
                        </div>
                    </div>
                </div>

                <!-- 新闻动态 -->
                <div class="productBigBox">
                    <div class="wrap visible">
                        <div style="width: 100%; height: 0.1px"></div>
                        <div class="pFlexBox noMt">
                            <div class="pTopTitle">{{ $t('新闻动态') }}</div>
                            <div class="rightBox" @click="goPage(2)"></div>
                        </div>
                        <div class="pSwiperBox">
                            <el-carousel height="300px" ref="pSwiper3" trigger="click" indicator-position="none" arrow="never">
                                <el-carousel-item v-for="(item, index) in listFormate(newsList)" :key="index">
                                    <div class="swiperFlexBox">
                                        <div class="swiperItemBox" @click="goNews(item2)" v-for="(item2, index2) in item" :key="index2">
                                            <el-image class="img" :src="item2.thumb" fit="cover"></el-image>
                                            <div class="pSwiperText">{{ lang == 'en' ? item2.enDescription : item2.description }}</div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                            <div class="leftBtn" @click="pSwiperLeft3"></div>
                            <div class="rightBtn" @click="pSwiperRight3"></div>
                        </div>
                    </div>
                </div>

                <!-- 关于海伦 -->
                <div class="productBigBox aboutBox">
                    <div class="wrap">
                        <div style="width: 100%; height: 0.1px"></div>
                        <div class="pFlexBox noMt">
                            <div class="pTopTitle">{{ $t('关于海伦') }}</div>
                            <div class="rightBox" @click="goPage(1)"></div>
                        </div>
                    </div>

                    <div class="aboutBgBox">
                        <div class="wrap">
                            <div class="aboutTitle">{{ $t('敲响中国爵士鼓制造业的新乐章') }}</div>
                            <div class="aboutFlexBox">
                                <div class="aboutTextBox" v-html="lang == 'en' ? aboutLeft.enContent : aboutLeft.content"></div>
                                <div class="aboutTextBox" v-html="lang == 'en' ? aboutRight.enContent : aboutRight.content"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 关于海伦 -->
                <!-- <div class="abouthl">
                    <div class="wrap">
                        <div class="aboutTitleBox">
                            <div class="aboutBigTitle">
                                <div class="lunboTitleText">Drums</div>
                                <img src="@/assets/img/index/logo.png" class="lunboLogo" alt="" />
                            </div>
                            <div class="abouthlTitle">关于海伦</div>
                        </div>
                        <div class="aboutFlexBox">
                            <div class="aboutText" v-html="aboutUs.content"></div>
                            <div class="rightBox">
                                <div class="rightTextBigBox">
                                    <div class="bigNumBox">
                                        <div class="bigNum">{{ aboutUs.expand1Num }}<span class="addNum">+</span></div>
                                        <div class="bigNumText">项</div>
                                    </div>
                                    <div class="bigNumNorText">{{ aboutUs.expand1Text }}</div>
                                </div>
                                <div class="rightTextBigBox">
                                    <div class="bigNumBox">
                                        <div class="bigNum">{{ aboutUs.expand2Num }}<span class="addNum">+</span></div>
                                        <div class="bigNumText">人</div>
                                    </div>
                                    <div class="bigNumNorText">{{ aboutUs.expand2Text }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="abouthlGoBtn" @click="goPage(1)"></div>
                </div> -->

                <!-- 留言给我们 -->
                <div class="messageBox" v-if="false">
                    <div class="wrap">
                        <div class="messageTitle">MESSAGE</div>
                        <div class="messageTitle2">{{ $t('留言给我们') }}</div>
                        <div class="msgInputFlexBox">
                            <div class="msgInputBox">
                                <input type="text" :placeholder="$t('您的姓名')" v-model="name" class="msgInput" />
                            </div>
                            <div class="msgInputBox">
                                <input type="text" :placeholder="$t('您的电话')" v-model="tel" class="msgInput" />
                            </div>
                        </div>
                        <div class="msgTextAreaBox">
                            <textarea class="msgTextArea" v-model="content" :placeholder="$t('留言内容')" cols="30" rows="2"></textarea>
                        </div>
                        <div class="msgSubBtn btn-ripple" @click="goPage(3)">{{ $t('私人定制') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import productList from '@/components/product/productList.vue'
import goTop from '@/components/goTop/goTop'

import { mapState } from 'vuex'

import dayjs from 'dayjs'

export default {
    name: 'index',
    components: {
        productList,
        goTop,
    },
    data() {
        return {
            swiperActiveIndex: 0, // banner激活选项卡

            swiperOption: {
                slidesPerView: 5,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },

            aboutUs: {},

            name: '',
            tel: '',
            content: '',

            newsList: [], // 新闻banner
            madeBannerList: [], // 私人定制banner

            pSearchSelectList: [], // 产品banner/产品搜索select，公用的
            pSearchSelectVal: '',

            artistList: [], // 签约艺术家banner

            pInputValue: '',

            aboutLeft: '', // 关于海伦-左侧文案
            aboutRight: '', // 关于海伦-右侧文案
        }
    },
    computed: {
        ...mapState(['index_banners']),
        listFormate() {
            return (val) => {
                function isArray(arg) {
                    if (typeof Array.isArray === 'undefined') {
                        return Object.prototype.toString.call(arg) === '[object Array]'
                    }
                    return Array.isArray(arg)
                }
                if (val && isArray(val)) {
                    let reviews_group = []
                    let items_length = 4 //4个一组
                    val.forEach((v, i) => {
                        let group_index = Math.floor(i / items_length)
                        if (!reviews_group[group_index]) {
                            reviews_group[group_index] = []
                        }
                        reviews_group[group_index].push(v)
                    })
                    return reviews_group
                } else {
                    return []
                }
            }
        },
    },

    watch: {},
    async created() {
        this.getAboutUs()
        this.getNews()
        this.getBanner()
        this.getProductChannel()
        this.getArtistList()
        this.getAboutNews()
    },
    mounted() {
        this.$refs.carousel.handleMouseEnter = () => {}
        this.$refs.carousel2.handleMouseEnter = () => {}
    },
    methods: {
        delHandleMouseEnter2() {
            this.$refs.carousel2.handleMouseEnter = () => {}
        },
        delHandleMouseEnter() {
            this.$refs.carousel.handleMouseEnter = () => {}
        },
        goNews(item) {
            this.$router.push({
                path: '/newsDetail',
                query: {
                    id: item.id,
                },
            })
        },
        goArtist(item) {
            this.$router.push({
                path: '/artistDetail',
                query: {
                    id: item.id,
                },
            })
        },
        queryBtnFun() {
            if (this.pInputValue == '') {
                alertErr(this.$t('请输入'))
                return
            }
            let pSearchTitle = ''
            for (let i = 0; i < this.pSearchSelectList.length; i++) {
                let item = this.pSearchSelectList[i]
                if (item.id == this.pSearchSelectVal) {
                    pSearchTitle = item.title
                    break
                }
            }
            this.$router.push({
                path: '/productListFirst',
                query: {
                    id: this.pSearchSelectVal,
                    title: pSearchTitle,
                    keyword: this.pInputValue,
                },
            })
        },
        async getArtistList() {
            let obj = {
                page: 1,
                pageNum: 999,
            }
            let res = await this.artistListsAjax(obj)
            if (res && res.code == 200) {
                this.artistList = res.data.list
            }
        },
        goProductListPage(item) {
            this.$router.push({
                path: '/productListFirst',
                query: {
                    id: item.id,
                    title: item.title,
                },
            })
        },
        async getProductChannel() {
            let obj = {}
            let res = await this.product_channelAjax(obj)
            if (res && res.code == 200) {
                let data = res.data
                this.pSearchSelectList = data
                this.pSearchSelectVal = data[0].id
            }
        },
        // 产品
        pSwiperLeft() {
            this.$refs['pSwiper'].prev()
        },
        // 产品
        pSwiperRight() {
            this.$refs['pSwiper'].next()
        },
        // 签约艺术家
        pSwiperLeft2() {
            this.$refs['pSwiper2'].prev()
        },
        // 签约艺术家
        pSwiperRight2() {
            this.$refs['pSwiper2'].next()
        },
        // 新闻动态
        pSwiperLeft3() {
            this.$refs['pSwiper3'].prev()
        },
        // 新闻动态
        pSwiperRight3() {
            this.$refs['pSwiper3'].next()
        },
        async getBanner() {
            let res = await this.bannerIndexAjax()
            if (res && res.code == 200) {
                for (let i = 0; i < res.data.length; i++) {
                    let item = res.data[i]
                    if (item.id == 178) {
                        this.madeBannerList = item.images
                        break
                    }
                }
            }
        },
        bannerIndexAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'banner_index',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        artistListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'artist_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        goNewsDetail(item) {
            this.$router.push({
                path: '/newsDetail',
                query: {
                    id: item.id,
                },
            })
        },
        async getNews() {
            let obj = {
                isIndex: 1,
                page: 1,
                pageNum: 100,
            }
            let res = await this.newsListsAjax(obj)
            if (res && res.code == 200) {
                let list = res.data.list
                this.newsList = list
            }
        },
        async getAboutNews() {
            let obj = {
                page: 1,
                pageNum: 100,
                channelId: 54,
                contentLen: 1,
            }
            let res = await this.newsListsAjax(obj)
            if (res && res.code == 200) {
                for (let i = 0; i < res.data.list.length; i++) {
                    let item = res.data.list[i]
                    if (item.id == 115) {
                        this.aboutLeft = item.content
                    }
                    if (item.id == 116) {
                        this.aboutRight = item.content
                    }
                }
            }
        },
        newsListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'news_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async getAboutUs() {
            let obj = {
                channelId: 10,
                id: 95,
            }
            let res = await this.newsDetailsAjax(obj)
            if (res && res.code == 200) {
                let data = res.data.info
                this.aboutUs = data
                if (data.expand1) {
                    let arr = data.expand1.split(',')
                    this.aboutUs.expand1Num = arr[0]
                    this.aboutUs.expand1Text = arr[1]
                }
                if (data.expand2) {
                    let arr = data.expand2.split(',')
                    this.aboutUs.expand2Num = arr[0]
                    this.aboutUs.expand2Text = arr[1]
                }
            }
        },
        newsDetailsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'news_detail',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 页面跳转
        async goPage(val) {
            if (val == 0) {
                // 私人定制
                this.$router.push('/product-made')
            } else if (val == 1) {
                // 关于海伦
                this.$router.push('/about')
            } else if (val == 2) {
                // 新闻动态
                this.$router.push('/news')
            } else if (val == 3) {
                // 留言给我们
                function checkPhone(tel) {
                    if (!tel) {
                        return false
                    }
                    let regu = /^1[3-9][0-9]{9}$/

                    if (regu.test(tel)) {
                        return true
                    } else {
                        return false
                    }
                }
                if (!this.name) {
                    alertErr('请输入您的姓名')
                    return
                }
                if (!checkPhone(this.tel)) {
                    alertErr('请输入有效的手机号')
                    return
                }
                if (!this.content) {
                    alertErr('请输入留言内容')
                    return
                }
                let obj = {
                    name: this.name,
                    phone: this.tel,
                    content: this.content,
                }
                this.$load.open()
                let res = await this.feedbackAddAjax(obj)
                await this.$load.close()
                if (res && res.code == 200) {
                    alertSucc('留言成功')
                    this.name = ''
                    this.tel = ''
                    this.content = ''
                } else {
                    alertErr('留言失败，请重试！')
                }
            } else if (val == 4) {
                // 签约艺术家
                this.$router.push('/artistList')
            } else if (val == 5) {
                // 产品列表
                this.$router.push('/productListFirst')
            }
        },
        feedbackAddAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'feedback_add',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // banner切换指示器切换激活
        swiperChange(index) {
            this.swiperActiveIndex = index
        },
        // banner点击指示器切换
        switchSwiper(index) {
            this.$refs.elcarousel.setActiveItem(index)
        },
        do_banner_click(item) {
            if (item.url) {
                window.open(item.url, '_blank')
            } else if (item.inventoryId) {
                this.$router.push('/product-detail/' + (item.skuId || item.inventoryId))
            }
        },
        product_channelAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'product_channel',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
    },
}
</script>

<style lang="less">
.pSelectpopper {
    .el-select-dropdown__item.selected {
        color: #ff4d00 !important;
    }

    .el-select-dropdown__item.hover {
        background: #ff4d00 !important;
        color: #fff;
    }
}

.pInput {
    width: 756px;
    height: 50px;

    .el-input__inner {
        width: 756px;
        height: 50px;
        font-size: 16px;
        line-height: 16px;
    }
}

.pSelect {
    width: 146px;
    height: 50px;
    margin-right: 28px;
    /* selecte 框的高度设置，默认是 40px*/
    .el-input__inner {
        height: 50px;
        font-size: 16px;
        line-height: 16px;
    }

    .el-input__inner::placeholder {
        font-size: 16px;
        line-height: 50px;
    }

    /* 下面设置右侧按钮居中 */
    .el-input__suffix {
        top: 16px;
    }
    .el-input__icon {
        line-height: inherit;
    }
    .el-input__suffix-inner {
        display: inline-block;
    }
}
@media screen and (max-width: 1024px) {
    .pInput {
        width: 100%;
        height: auto;

        .el-input__inner {
            width: 100%;
            height: auto;
            padding: 10px 10px;
            font-size: 16px;
            line-height: 16px;
        }
    }

    .pSelect {
        width: 100%;
        height: auto;
        margin-right: 0;
        margin-top: 20px;
        margin-bottom: 10px;
        /* selecte 框的高度设置，默认是 40px*/
        .el-input__inner {
            height: auto;
            padding: 10px 10px;
            font-size: 16px;
            line-height: 16px;
        }

        .el-input__inner::placeholder {
            font-size: 16px;
            line-height: 50px;
        }

        /* 下面设置右侧按钮居中 */
        .el-input__suffix {
            top: 0;
        }
        .el-input__icon {
            line-height: inherit;
        }
        .el-input__suffix-inner {
            display: inline-block;
        }
    }
}
</style>

<style scoped lang="less">
.swiper-container {
    width: 100%;
    height: 900px;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background: #4ca5e4;
    color: #fff !important;
}

.el-select-dropdown__item.selected {
    color: #4ca5e4;
}
</style>

<style scoped lang="less">
/deep/ .el-rate__icon {
    font-size: 20px;
    margin-right: 0;
}

.banner-box .lunbo-box {
    position: relative;
    width: 100%;
    height: 800px;

    /deep/ .el-carousel__container {
        height: 800px;
    }

    /deep/ img {
        width: 100%;
        height: 800px;
    }

    /deep/ .el-carousel__arrow {
        display: none;
    }

    .swiperHintFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 26px;
        left: 0;
        z-index: 9;

        .swiperHint {
            cursor: pointer;
            width: 16px;
            height: 16px;
            background: #ffffff;
            border-radius: 50%;
            margin-right: 32px;

            &.active {
                background: transparent;
                width: 24px;
                height: 24px;
                border: 3px solid #ff4d00;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.pSearchBgBox {
    width: 100%;
    height: 159px;
    background-image: url('../assets/img/index/pSearchBg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        // font-size: 50px;
        // color: #ffffff;
        // line-height: 50px;
        font-size: 24px;
        color: #ffffff;
        line-height: 24px;
        margin-right: 98px;
    }

    .pQueryBtn {
        width: 164px;
        height: 50px;
        background: #ff4d00;
        border-radius: 4px 4px 4px 4px;
        margin-left: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .queryBtn {
            display: block;
            width: 24.64px;
            margin-right: 10px;
        }

        .queryBtnText {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            line-height: 18px;
        }
    }
}

.lunboTitleBox {
    width: 100%;
    height: 800px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 9;

    .lunboTitleFlexBox {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;

        .lunboLogo {
            width: 350px;
            height: auto;
            display: block;
            margin-right: 10px;
        }

        .lunboTitleText {
            font-size: 62px;
            line-height: 62px;
            color: #ffffff;
            font-family: myTextStyle;
            // font-family: Oswald, sans-serif;
        }
    }

    .lunboTitleText2 {
        width: 100%;
        font-family: Source Han Sans CN, Source Han Sans CN;
        // font-family: Oswald, sans-serif;
        font-weight: bold;
        font-size: 44px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        font-style: normal;
        margin-top: 20px;
        letter-spacing: 8px;
    }
}

.wrap {
    width: calc(100% - 160px - 160px);
    margin: 0 auto;
    overflow: hidden;
    position: relative;

    &.visible {
        overflow: visible;
    }
}

.productBigBox {
    width: 100%;
    height: 520px;
    background: #ffffff;

    &.aboutBox {
        height: 815px;
        background: transparent;
    }

    .aboutBgBox {
        width: 100%;
        height: 700px;
        background-image: url('../assets/img/index/aboutBgNew.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-top: 50px;

        .aboutTitle {
            width: 100%;
            text-align: center;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            // font-size: 36px;
            // color: #ffffff;
            // line-height: 36px;
            font-size: 24px;
            color: #ffffff;
            line-height: 24px;
        }

        .aboutFlexBox {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            margin-top: 33px;
        }

        .aboutTextBox {
            width: calc((100% - 70px) / 2);
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 26px;
        }
    }

    .pFlexBox {
        margin-top: 50px;
        margin-bottom: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.noMt {
            margin-top: 0;
        }
    }

    .pTopTitle {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        // font-size: 50px;
        // color: #000000;
        // line-height: 50px;
        font-size: 24px;
        color: #000000;
        line-height: 24px;
    }

    .rightBox {
        width: 70px;
        height: 70px;
        background: url('../assets/img/index/go.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
            background: url('../assets/img/index/go2.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .pSwiperBox {
        width: 100%;
        height: 300px;
        position: relative;

        .leftBtn {
            width: 30.15px;
            height: 52.34px;
            background-image: url('../assets/img/index/lastIcon.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 100px;
            left: -66px;
            cursor: pointer;

            &:hover {
                background-image: url('../assets/img/index/lastIcon2.png');
            }
        }

        .rightBtn {
            width: 30.15px;
            height: 52.34px;
            background-image: url('../assets/img/index/nextIcon.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 100px;
            right: -66px;
            cursor: pointer;

            &:hover {
                background-image: url('../assets/img/index/nextIcon2.png');
            }
        }

        .swiperFlexBox {
            width: 100%;
            // height: 300px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .swiperItemBox {
                width: calc((100% - 30px * 3) / 4);
                // height: 300px;
                margin-right: 30px;
                cursor: pointer;

                .img {
                    width: 100%;
                    height: 252px;
                    border-radius: 10px;
                }

                &:nth-child(4n) {
                    margin-right: 0;
                }

                .pSwiperText {
                    width: 100%;
                    height: 56px;
                    margin-top: 10px;
                    text-align: center;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: 18px;
                    color: #000000;
                    line-height: 28px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                &:hover {
                    .pSwiperText {
                        color: #ff5310;
                    }
                }
            }
        }
    }
}

.customBox {
    width: 100%;
    background: #ffffff;
    overflow: hidden;
    padding-bottom: 50px;

    .swiperBox {
        width: 100%;
        height: 700px;
        margin-top: 30px;

        .customSwiperItem {
            width: 100%;
            height: 700px;

            .img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .customTopFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 50px;

        .leftBox {
            .leftText {
                font-family: myTextStyle;
                font-weight: 400;
                font-size: 65px;
                line-height: 65px;
                color: #ff4d00;
            }
            .leftText2 {
                font-weight: bold;
                // font-size: 50px;
                // line-height: 50px;
                font-size: 24px;
                line-height: 24px;
                color: #000000;
            }
        }

        .rightBox {
            width: 70px;
            height: 70px;
            background: url('../assets/img/index/go.png') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;

            &:hover {
                background: url('../assets/img/index/go2.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .mediaBox {
        width: 730px;
        height: 609px;
        margin: -10px auto 0 auto;

        .mediaStyle {
            width: 100%;
            height: 100%;
            margin: 0 atuo;
        }
    }

    .customTitleFlexBox {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-top: 68px;

        .lunboLogo {
            width: 460px;
            height: auto;
            display: block;
            margin-right: 10px;
        }

        .lunboTitleText {
            font-size: 80px;
            line-height: 80px;
            color: #000000;
            font-family: myTextStyle;
        }
    }
}

.abouthl {
    width: 100%;
    height: 950px;
    background: url('../assets/img/index/aboutBg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;

    .abouthlGoBtn {
        width: 70px;
        height: 70px;
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        background: url('../assets/img/index/go.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
            background: url('../assets/img/index/go2.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .aboutFlexBox {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 117px;

        .aboutText {
            width: 70%;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 35px;
        }

        .rightBox {
            width: calc(30% - 135px);
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;

            .rightTextBigBox {
                margin-bottom: 116px;

                &:last-child {
                    margin-bottom: 0;
                }

                .bigNumBox {
                    display: flex;
                    align-items: flex-end;
                    justify-content: flex-start;
                    .bigNum {
                        font-weight: 900;
                        font-size: 70px;
                        color: #ff4d00;
                        position: relative;

                        .addNum {
                            font-weight: 900;
                            font-size: 36px;
                            color: #ff4d00;
                            position: relative;
                            top: -36px;
                        }
                    }

                    .bigNumText {
                        font-weight: 500;
                        font-size: 25px;
                        line-height: 70px;
                        color: #ffffff;
                    }
                }

                .bigNumNorText {
                    font-weight: 400;
                    font-size: 25px;
                    line-height: 25px;
                    color: #ffffff;
                }
            }
        }
    }

    .aboutTitleBox {
        margin-top: 135px;

        .abouthlTitle {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 50px;
            line-height: 50px;
            color: #ffffff;
            margin-top: 10px;
        }

        .aboutBigTitle {
            width: 100%;
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;

            .lunboLogo {
                width: 370px;
                height: auto;
                display: block;
            }

            .lunboTitleText {
                font-size: 80px;
                line-height: 80px;
                color: #ffffff;
                font-family: myTextStyle;
                margin-right: 10px;
            }
        }
    }
}

.newsBox {
    width: 100%;
    height: 830px;
    position: relative;

    .newsSwiperLast {
        width: 30.15px;
        height: 52.34px;
        position: absolute;
        left: 80px;
        top: 54%;
        transform: translateY(-50%);
        background: url('../assets/img/index/lastIcon.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
            background: url('../assets/img/index/lastIcon2.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .newsSwiperNext {
        width: 30.15px;
        height: 52.34px;
        position: absolute;
        right: 80px;
        top: 54%;
        transform: translateY(-50%);
        background: url('../assets/img/index/nextIcon.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
            background: url('../assets/img/index/nextIcon2.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .newsSwiper {
        width: 100%;
        height: 365px;
        overflow: hidden;

        .newsThreeItemBox {
            width: 100%;
            height: 365px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .newsItem {
                width: 30%;
                height: 100%;
                margin-right: 5%;
                cursor: pointer;

                .newsImg {
                    width: 100%;
                    height: 260px;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-bottom: 36px;
                }

                .newsText {
                    width: 100%;
                    height: 70px;
                    font-weight: 500;
                    font-size: 25px;
                    color: #000000;
                    line-height: 35px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                &:last-child {
                    margin-right: 0;
                }

                &:hover {
                    .newsText {
                        color: #ff4d00;
                    }
                }
            }
        }
    }

    .newsGoBtn {
        width: 70px;
        height: 70px;
        position: absolute;
        top: 170px;
        right: 0;
        background: url('../assets/img/index/go.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
            background: url('../assets/img/index/go2.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .newsTopTitle {
        margin-top: 110px;
        width: 100%;
        margin-bottom: 100px;

        .newsTopTitleText {
            width: 100%;
            text-align: center;
            font-weight: 400;
            font-size: 65px;
            line-height: 65px;
            color: #ff4d00;
            font-family: myTextStyle;
        }

        .newsTopTitleText2 {
            width: 100%;
            text-align: center;
            font-weight: bold;
            font-size: 50px;
            line-height: 50px;
            color: #000000;
        }
    }
}

.messageBox {
    width: 100%;
    height: 650px;
    background: url('../assets/img/index/messageBg.png') no-repeat;
    background-size: 100% 100%;

    .messageTitle {
        font-weight: 400;
        font-size: 65px;
        color: #ff4d00;
        line-height: 75px;
        width: 100%;
        text-align: center;
        margin-top: 130px;
        font-family: myTextStyle;
    }

    .messageTitle2 {
        font-weight: bold;
        font-size: 50px;
        line-height: 50px;
        color: #ffffff;
        width: 100%;
        text-align: center;
        margin-bottom: 87px;
    }

    .msgInputFlexBox {
        width: 64vw;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;

        .msgInputBox {
            width: 45%;
            height: 50px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #707070;
            margin-right: 10%;
            padding: 0 18px;
            overflow: hidden;

            &:last-child {
                margin-right: 0;
            }

            .msgInput {
                width: 100%;
                font-size: 18px;
                line-height: 50px;
                color: #444444;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;

                &::placeholder {
                    font-size: 18px;
                    font-weight: 500;
                    line-height: 50px;
                    color: #444444;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                }
            }
        }
    }

    .msgTextAreaBox {
        width: 64vw;
        margin: 0 auto;
        height: 100px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #707070;
        overflow: hidden;
        padding: 18px;
        margin-top: 25px;

        .msgTextArea {
            width: 100%;
            height: 100%;
            font-size: 18px;
            line-height: 25px;
            color: #444444;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            border: none;
            outline: none; /*边线不显示*/
            resize: none; /*禁止拉伸*/
            appearance: none;

            &::placeholder {
                font-size: 18px;
                line-height: 25px;
                color: #444444;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;
            }
        }
    }

    .msgSubBtn {
        width: 300px;
        height: 50px;
        background: #ff4d00;
        border-radius: 0px 0px 0px 0px;
        margin: 25px auto 0 auto;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        line-height: 20px;
        color: #ffffff;
    }
}

.page {
    background: #ffffff;
    padding-top: 0;
    // padding-bottom: 95px;

    // background: #fff;
    .inner {
        padding-top: 0;
        // width: @width;
        margin: 0 auto;
        position: relative;
    }
}

.sec-item {
    padding-top: 40px;

    .sec-title {
        margin-bottom: 73px;
        text-align: center;
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 40px;
        color: #333333;
    }

    .sec-ctx {
        width: @width;
        margin: 0 auto;
    }

    .more-box {
        margin-top: 72px;
        text-align: center;

        a {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            height: 50px;
            background: #4ca5e4;
            border-radius: 0px 0px 0px 0px;

            font-family: OPPOSans, OPPOSans;
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/mobile/index.less"></style>
